import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface VenueAccessResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VenueAccessService {
  private readonly apiUrl = 'https://api.indietown.org/api/preview/venues';
  private accessCache$: Observable<boolean>;

  constructor(private http: HttpClient) {}

  /**
   * Checks if the user has access to the venue guide
   * @returns Observable<boolean> - true if user has access, false otherwise
   */
  checkVenueAccess(): Observable<boolean> {
    // Return cached result if available
    if (this.accessCache$) {
      return this.accessCache$;
    }

    // Make the API request and cache the result
    this.accessCache$ = this.http.get<VenueAccessResponse>(this.apiUrl).pipe(
      map(response => response.success),
      catchError(() => of(false)),
      shareReplay(1) // Cache the result
    );

    return this.accessCache$;
  }

  /**
   * Clears the cached access status
   */
  clearCache(): void {
    this.accessCache$ = null;
  }
}